import { ColoursObj, getContrastYIQ, Typography } from "@eventr/common-storybook";
import { useMemo, type JSX } from "react";
import { useSectionV2Context } from "../v2/state/sectionProvider";

interface ICountLabelProps {
  id?: string;
  count?: number;
  bgColor?: string;
}

export const CountLabel = ({ id, count = 0, bgColor }: ICountLabelProps): JSX.Element | null => {
  const { isPublic } = useSectionV2Context();

  const backgroundColor = useMemo<string>(() => {
    if (bgColor) return bgColor;
    return isPublic ? ColoursObj.coreBrights.tertiary : ColoursObj.backgrounds.secondary;
  }, [bgColor, isPublic]);

  if (count === 0) {
    return null;
  }
  const isCompactDigits = count < 100;

  return (
    <Typography
      id={id ? `count-label.${id}` : undefined}
      variant="bodyBold"
      sx={{
        display: "flex",
        justifyContent: "center",
        padding: `4px ${isCompactDigits ? "8px" : "4px"}`,
        gap: "8px",
        borderRadius: "4px",
        background: backgroundColor,
        lineHeight: "16px",
        fontWeight: 300,
        fontSize: "12px",
        height: "fit-content",
        width: isCompactDigits ? "8px" : "auto",
        color: getContrastYIQ(backgroundColor),
      }}
    >
      {count.toString()}
    </Typography>
  );
};
